import { ArrowBack } from "@mui/icons-material";
import { Alert, Link as A, Button } from "@mui/material";
import { Link } from "react-router-dom";

export default function DpcError({status}){

    const messages = {
        404: 'Votre inscription est introuvable.',
        402: 'Vos crédits DPC sont épuisés. Vous ne pouvez pas vous inscrire à cette action.',
        409: "L'inscription a échoué. Veuillez vérifier que vous n'êtes pas déjà inscrit à cette formation."
    };

    let message = messages[status] || messages[404];

    return <>

        <Alert severity='warning'>
            {message} Contactez Montaine au <A href='tel:+33554547771'>05 54 54 77 71</A> ou à <A href='mailto:sav@learnylib.com'>sav@learnylib.com</A>
        </Alert>

        <Button component={Link} to="/" startIcon={<ArrowBack />}>
            Retour à l'accueil
        </Button>

    </>
}

